import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'uptiv-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Uptiv Health',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1,
  email: '@',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/up/index.js